import * as React from 'react';
import WeekStartersEnum from '../enums/WeekStartersEnum';
var WeeklyContextMobile = React.createContext({
    dateOnFocuse: {},
    setCurrentWeekRange: function (data) { },
    setHeaderPickerDate: function (data) { },
    rerenderTitleHandler: {},
    date: {},
    calendarRef: {},
    dates: {},
    timezone: '',
    isPrivateEventsShown: false,
    // recurrenceArr: [],
    firstDay: 0,
    privetEventsTitle: 'Private',
    isMobile: true,
    calendarsList: [],
    locale: 'en',
    timeFormat: '',
    openPopup: function (_a) {
        var popup = _a.popup, expandedEventsProps = _a.expandedEventsProps, expandedData = _a.expandedData, isCloseFocused = _a.isCloseFocused;
    },
    onCopyClick: {},
    onLocationClick: {},
    onAttachmentClick: {},
    weekStarter: WeekStartersEnum.Sunday,
    experiments: [],
});
export default WeeklyContextMobile;
//# sourceMappingURL=weeklyContextMobile.js.map